// GH emits deviceTimeZone as a ±HH:MM UTC offset; getTimezoneOffset returns
// minutes BEHIND UTC (positive west of UTC), so the sign is inverted.
function utcOffsetLabel(offsetMinutes: number): string {
    const sign = offsetMinutes <= 0 ? '+' : '-'
    const hours = Math.floor(Math.abs(offsetMinutes) / 60)
    const minutes = Math.abs(offsetMinutes) % 60
    return `${sign}${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`
}

/** GH's SDK-level `deviceTimeZone`, which every MusicMetrix action of every family carries. */
export const metricDeviceTimeZone: string = utcOffsetLabel(new Date().getTimezoneOffset())
